import(/* webpackMode: "eager" */ "/opt/customer-accounts/src/app/login/page.tsx");
